import { Controller } from "@hotwired/stimulus"

// Client-only UI for the flag reporter overlay: open and close the panel,
// and once the one-time "reported" confirmation is dismissed reveal the
// persistent "already reported" view with the revoke action. All reporting
// and revoking happens through real form submissions answered with
// turbo_stream responses.
export default class extends Controller {
  static get targets() {
    return ["panel", "success", "undo"]
  }

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden
    if (this.panelTarget.hidden) {
      this.dismissSuccess()
    }
  }

  close() {
    this.panelTarget.hidden = true
    this.dismissSuccess()
  }

  // The success confirmation is shown once, immediately after reporting.
  // Remove it (rather than just hiding it — .success-state sets an explicit
  // display that beats the [hidden] attribute) so reopening the panel shows
  // only the persistent "already reported" view.
  dismissSuccess() {
    if (this.hasSuccessTarget) {
      this.successTarget.remove()
    }
    if (this.hasUndoTarget) {
      this.undoTarget.hidden = false
    }
  }
}
